import React from 'react';
import ReactDOM from 'react-dom';
import Root from './scenes/Root';
import { unregister } from './registerServiceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/index.css';

import ReactPixel from 'react-facebook-pixel';

ReactDOM.render(<Root />, document.getElementById('root'));
unregister();

ReactPixel.init('361070971194079');



// WEBPACK FOOTER //
// ./src/index.js